export function isDate(value: any): value is Date {
  return value instanceof Date && !isNaN(+value);
}



// WEBPACK FOOTER //
// ./~/rxjs/src/util/isDate.ts